import { Component } from "react";
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Header from '../../common_components/Header';
import { get_report_list_action } from "../../actions/report_action/report_action";
import Footer from "../../common_components/Footer";
import { sessionExpireMessage, toastError, tokenInavlidMessage } from "../../utils/constants";

class ReportList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            panel: null,
            reportList: [],
            cmsMenuData: [], cmsFooterData: [],
        }

    }
    componentDidMount() {
        console.log("componentDidMount called");
        if (!JSON.parse(sessionStorage.getItem("loginDataSS"))) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
            return;
        }
        window.scrollTo(0, 0);

        this.getReportList();
    }


    handleChange(panel) {
        if (panel == this.state.panel) {
            this.setState({ panel: null })
        }
        else {
            this.setState({ panel: panel })
        }
    }

    getReportList() {
        console.log('enter')
        this.setState({ isLoading: true })
        this.props.get_report_list_action()
            .then((data) => {
                this.setState({ isLoading: false })
                if (data.error != 1) {
                    this.createReportList(data.data)
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            })
            .catch((err) => {
                this.setState({ isLoading: false })

                console.log(err)
            })
    }

    createReportList(list) {
        let tempReportGroupList = [];
        let tempList = [];

        for (let i = 0; i < list.length; i++) {
            if (!tempReportGroupList.includes(list[i].report_group_id)) {
                tempReportGroupList.push(list[i].report_group_id);
                const obj = {
                    report_group_id: list[i].report_group_id,
                    ReportGroup: list[i].ReportGroup
                };
                tempList.push(obj);
            }
        }

        for (let i = 0; i < tempList.length; i++) {
            let tempSubReportList = [];
            for (let j = 0; j < list.length; j++) {
                if (tempList[i].report_group_id === list[j].report_group_id) {
                    tempSubReportList.push(list[j]);
                }
            }
            tempList[i].subReportList = tempSubReportList;
        }

        setTimeout(() => {
            this.setState({ reportList: tempList });
        }, 100);
    }

    reportNavigate(report_id, ReportGroup) {

        this.props.navigate('/reportGenerator', { state: { report_id: report_id, ReportGroup: ReportGroup } })


    }


    render() {
        const { isLoading, panel, reportList, cmsMenuData, cmsFooterData } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <Header headerNavs={cmsMenuData} />
                <section class="registration_form">
                    <div class="container">
                        <div class="row mt-15">
                            <section className="table_section">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-lg-12">
                                            <div className="card shadow-none border mb-2" >
                                                <div className="card-header py-1">
                                                    <h6 className='pt-2' style={{ float: 'left' }}>Reports</h6>
                                                </div>
                                            </div>
                                                <div className="card-body  p-2 pb-0">
                                                    {reportList.length > 0 ? reportList.map((data, i) => (
                                                        <Accordion key={i} className="m-1 p-0 border" expanded={panel === i} onChange={() => this.handleChange(i)}>
                                                            <AccordionSummary className="py-1" style={{ minHeight: '35px', borderBottom: '1px solid #ddd', borderBottom: '1px solid #ddd', }}
                                                                expandIcon={<ExpandMoreIcon />}
                                                                aria-controls={`panel${i}-content`}
                                                                id={`panel${i}-header`}
                                                            >
                                                                <Typography className="m-0" sx={{ width: '33%', flexShrink: 0 }}>
                                                                    {data.ReportGroup}
                                                                </Typography>
                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                                                <Typography component="div">
                                                                    <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                                                                        {data.subReportList.length > 0 ? data.subReportList.map((subdata, index) => (
                                                                            <li
                                                                                key={index}
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => this.reportNavigate(subdata.report_id, subdata.ReportGroup)}
                                                                                className="mb-2"
                                                                            >
                                                                                <a>{`${index + 1}.`} {subdata.report_name}</a>
                                                                            </li>
                                                                        )) : (
                                                                            <li>No Subreport Found</li>
                                                                        )}
                                                                    </ul>
                                                                </Typography>
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    )) : (
                                                        <div className="text-center">No Report Found</div>
                                                    )}
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </section>
                <Footer footerData={cmsFooterData} />

            </>
        )
    }
}

export default withRouter(connect(null, { get_report_list_action })(ReportList))